import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import {ConfigService} from "../../app/config.service";

/**
 * Generated class for the ModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modal',
  templateUrl: 'modal.html',
})
export class ModalPage {

  public color;
  public language;

  constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, private configService: ConfigService) {
    this.color=this.configService.config['color1'];
    this.language=this.configService.config['language'];
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ModalPage');
  }

  closeModal() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modal/modal.ts